import { StyleSheet } from 'react-native';
import { brand, neutrals, alert, background, buttons, text } from 'src/theme/colors';

const sharedStyle = StyleSheet.create({
  page: {
    flex: 1,
  },
  button: {
    backgroundColor: buttons.primary.buttonPrimaryBackgroundDefault,
    borderRadius: 100,
    paddingVertical: 8,
    paddingHorizontal: 18,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  bottomContent: {
    alignItems: 'center',
    gap: 8,
  },
  redirectText: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    textAlign: 'center',
    color: neutrals.black,
  },
  redirectCta: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  },
  redirectCtaIcon: {
    color: brand.main.water,
  },
  errorTitle: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
  },
  errorDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 21,
    color: alert.alertRed,
    paddingLeft: 24,
  },
  errorMessage: {
    position: 'absolute',
    bottom: 50,
    textAlign: 'center',
    width: 380,
  },
  icon: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
  textCta: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 18,
    color: text.color.interactive,
    textDecorationLine: 'none',
    borderBottomWidth: 0,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  header: {
    backgroundColor: neutrals.white,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 12,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 24,
    textAlign: 'center',
  },
  container: { flex: 1, justifyContent: 'center', alignItems: 'center' },
  uploadContent: { gap: 32, alignItems: 'center' },
  uploadingContent: { gap: 32, alignItems: 'center', width: '100%', paddingHorizontal: 32 },
  uploadedContent: { gap: 80, alignItems: 'center', width: '100%', paddingHorizontal: 32 },
  progressBar: {
    width: '100%',
    height: 30,
  },
  topContent: {
    gap: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: 1,
    backgroundColor: neutrals.white,
  },
  textWrapper: {
    alignItems: 'center',
    gap: 11,
    width: 310,
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 29,
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 22,
    textAlign: 'center',
  },

  redirectCtaText: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  header: {
    backgroundColor: neutrals.white,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 12,
    shadowColor: neutrals.black,
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 0,
      height: 0,
    },
    shadowRadius: 20,
    position: 'relative',
    zIndex: 2,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 27,
    textAlign: 'center',
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: background.backgroundColorBrand,
    borderRadius: 20,
    gap: 40,
  },
  uploadContent: {
    alignItems: 'center',
    gap: 40,
  },
  uploadingContent: {
    alignItems: 'center',
    gap: 40,
  },
  uploadedContent: {
    alignItems: 'center',
    gap: 48,
  },
  topContent: {
    alignItems: 'center',
    gap: 24,
  },
  progressBar: {
    width: '100%',
    height: 30,
  },
  body: {
    flex: 1,
    backgroundColor: neutrals.white,
    paddingVertical: 32,
    paddingHorizontal: 40,
  },
  textWrapper: {
    alignItems: 'center',
    gap: 11,
    maxWidth: 510,
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    lineHeight: 31,
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 24,
    textAlign: 'center',
  },
  redirectCtaText: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
  },
});
